







































import { Component, Vue } from 'vue-property-decorator';
import VxBreadcrumb from '@/layouts/components/VxBreadcrumb.vue';
import BookingComponent from '@/components/common/BookingComponent.vue';
import router from '@/router';
import AuthModule from '@/store/AuthModule';
import { postFinanceRequest } from '@/api/api';

@Component({
    components: {
    },
})
export default class FinanceRequest extends Vue {
    request_comments = '';
    fileInput: File | null = null;
    file: { name: string; content: string } | null = null;

    async sendRequest() {
        const $vs = (this as any).$vs;
        $vs.loading()
        try {
            const { data } = await postFinanceRequest({
                comments: this.request_comments,
                file: this.file ? this.file.content : null,
            })
            this.request_comments = '';
            this.fileInput = null;
            this.file = null;
            $vs.loading.close()
            return $vs.notify({
                color: 'success',
                position: 'top-right',
                title: "Succès",
                text: "Demande envoyée",
            });
        } catch {
            $vs.loading.close()
            return $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: "Succès",
                text: "Erreur lors de l'envoi de votre demande",
            });
        }
    }

    onFileChange(event: any) {
        const target = event.target as HTMLInputElement;

        if (target && target.files) {
            const file: File = target.files[0];

            const reader: FileReader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = (readerEvent: any) => {
                this.file = {
                    name: file.name,
                    content: readerEvent.target.result,
                };
            };
        }
    }
}
